import * as Yup from "yup";

export const passwordValidator = Yup.string()
  .min(6, "validation.passwordLength")
  .matches(/(\d\D)|(\D\d)/, "validation.passwordValidation");
